module.exports = __webpack_public_path__ + "static/media/28DGC5.dc843b9c.jpg";